import auth0Config from "./auth0ConfigHelper";

export const restrictedApps = [
  "Brightcove Beacon iOS",
  "Brightcove Beacon tvOS",
];

export const handleCookiePreferences = (): void => {
  try {
    const loginHint = auth0Config?.extraParams.login_hint;
    const title = auth0Config.dict.signin.title;

    const { consentRejected } = (
      loginHint ? JSON.parse(loginHint) : {}
    ) as Record<string, unknown>;

    if (consentRejected || restrictedApps.includes(title)) {
      const dateSet = new Date();
      const dateExpires = new Date();
      dateExpires.setFullYear(dateSet.getFullYear() + 1);
      document.cookie = `OptanonAlertBoxClosed=${dateSet.toISOString()}; expires=${dateExpires.toISOString()}; path=/ ; sameSite=lax`;
    }
  } catch {
    console.info(
      "Can not determine whether to reject optional cookies by default",
    );
  }
};
